module.exports = __webpack_public_path__ + "media/images/orion_pictos/driving-c2b8e0b8a12ad6cb8ad10080c23f022d.svg";